export const ua_navigationdata = {
  items: [
    {
      id: 1,
      name: "Домівка",
      path: "/",
    },
    {
      id: 2,
      name: "Каталог",
      path: "/catalog",
    },
    {
      id: 3,
      name: "Про компанію",
      path: "/about",
    },
    {
      id: 4,
      name: "Вакансії",
      path: "/job",
    },
    {
      id: 5,
      name: "Контакти",
      path: "/contacts",
    },
  ],
};
